import React, { FC, useState } from 'react';
import { cn } from '@bem-react/classname';
import { YAText } from '@ui-kit';
import { IWorkItemCardProps } from './WorkItemCard.types';
import { formatPrice } from '@utils/number';
import Carousel from 'react-gallery-carousel';
import 'react-gallery-carousel/dist/index.css';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './WorkItemCard.styles.scss';
import Media from '../Media/Media';

const CnWorkItem = cn('work-item');

const WorkItemCard: FC<IWorkItemCardProps> = (props) => {
  const { name, info, isSmall, author, priceInfo, size, year, img, id, price, media, onItemClick } =
    props;
  const [isImageLoad, setIsImageLoad] = useState(false);

  return (
    <div className={CnWorkItem({ isSmall })} onClick={() => onItemClick(id)}>
      <div className={CnWorkItem('content', { isSmall })}>
        {img.length > 1 ? (
          <div
            style={{ paddingBottom: 10 }}
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
            }}
          >
            <Carousel
              style={{ height: isSmall ? 150 : 300, width: '100%' }}
              shouldLazyLoad={false}
              hasThumbnails={false}
              canAutoPlay={false}
              hasLeftButton={false}
              hasRightButton={false}
              hasMediaButton={false}
              hasSizeButton={false}
              hasIndexBoard={false}
              hasDotButtons={'bottom'}
              images={img?.map((item) => ({ src: item }))}
            />
          </div>
        ) : (
          <div className={CnWorkItem('image-container', { isSmall })}>
            <img
              className={CnWorkItem('image', { isSmall })}
              src={img[0]}
              alt={name}
              onLoad={() => {
                setIsImageLoad(true);
              }}
            />
            {!isImageLoad && (
              <Spin
                size={'large'}
                className={CnWorkItem('image-spin')}
                indicator={<LoadingOutlined spin />}
              />
            )}
          </div>
        )}
        {name && <YAText className={CnWorkItem('name')} text={name} type={'H3'} />}
        {author && (
          <YAText className={CnWorkItem('description')} isBold text={author} type={'description'} />
        )}
        {info && <YAText className={CnWorkItem('description')} text={info} type={'description'} />}
        {size && <YAText className={CnWorkItem('description')} text={size} type={'description'} />}
        {year && <YAText className={CnWorkItem('description')} text={year} type={'description'} />}
      </div>
      <div className={CnWorkItem('info', { isSmall })}>
        {media?.length && <Media media={media} id={id} isSmall={isSmall} />}
        <YAText
          text={`${price ? formatPrice(price) + ' ₽ ' : ''}${priceInfo ?? ''}`}
          isBold
          type={'label'}
        />
      </div>
    </div>
  );
};

export default WorkItemCard;
